export const topicWall = {
  groups: [
    {
      id: 'event',
      label: '事件类型',
      hint: '先认类型，再决定要不要细看',
      tags: [
        { id: 'tafang', name: '塌房', count: 148 },
        { id: 'fanche', name: '翻车', count: 132 },
        { id: 'zhengyi', name: '争议', count: 205 },
        { id: 'chouwen', name: '丑闻', count: 96 },
        { id: 'chaoxi', name: '抄袭', count: 61 },
        { id: 'sifan', name: '撕番', count: 44 },
        { id: 'shuadapai', name: '耍大牌', count: 53 },
        { id: 'xueli', name: '学历存疑', count: 22 },
      ],
    },
    {
      id: 'focus',
      label: '争议焦点',
      hint: '同一条线里，真正吵起来的那一点',
      tags: [
        { id: 'ganqing', name: '感情线', count: 88 },
        { id: 'caizheng', name: '财务纠纷', count: 47 },
        { id: 'hezuo', name: '合作纠纷', count: 39 },
        { id: 'yanlun', name: '言论失当', count: 74 },
        { id: 'weigui', name: '违规代言', count: 31 },
        { id: 'shuju', name: '数据造假', count: 58 },
        { id: 'peichang', name: '赔偿', count: 26 },
        { id: 'xuanjiao', name: '选角风波', count: 18 },
      ],
    },
    {
      id: 'status',
      label: '状态标签',
      hint: '看状态，省掉反复刷帖',
      tags: [
        { id: 'shichui', name: '已实锤', count: 112 },
        { id: 'fanzhuan', name: '出现反转', count: 66 },
        { id: 'jinxing', name: '进行中', count: 84 },
        { id: 'lengchuli', name: '冷处理', count: 40 },
        { id: 'chengqing', name: '已澄清', count: 37 },
        { id: 'jieguo', name: '已出结果', count: 96 },
      ],
    },
  ],
};